import { createSlice } from '@reduxjs/toolkit';
import commonConstants from '../../constants/common.constant';

export type User = {
  id: string;
  username: string;
  email: string;
  phone: string;
  vendor: {
    is_approved: boolean;
    first_name?: string;
    last_name?: string;
    business_name?: string;
    abn?: string;
    year_of_incorporation?: string;
    domain?: string;
    business_category?: string;
    logo?: string;
  };
};

type AuthState = {
  isAuthenticated: boolean;
  user: User | null;
  userType: string;
};

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  userType: commonConstants.ROLE.REFERRER_ROLE,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.userType = action.payload.role;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

export const { login, logout, setUserType } = authSlice.actions;

export default authSlice.reducer;
